import type * as React from 'react';
import { get } from '@Domain/Api';
import subjectTypesFetched, {
	type SubjectTypePayload,
	type SubjectTypesFetchedAction,
} from '@Application/SubjectTypes/Actions/subjectTypesFetched';
import subjectTypesFetchFailed, {
	type SubjectTypesFetchFailedAction,
} from '@Application/SubjectTypes/Actions/subjectTypesFetchFailed';
import type FetchSubjectTypes from '@Application/SubjectTypes/Queries/FetchSubjectTypes';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = SubjectTypesFetchedAction | SubjectTypesFetchFailedAction;

export default (query: FetchSubjectTypes) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const types = await get<SubjectTypePayload[]>(
				`${parameters.api.host}/api/accounts/${query.accountId}/subject-types`,
			);

			const action = subjectTypesFetched(query.accountId, types);
			dispatch(action);
			return action;
		} catch (error) {
			const action = subjectTypesFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
